import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from 'Layout';
import NonAuthLayout from 'Layout/NonAuthLayout';

//routes
import { publicRoutes, authProtectedRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';
import { getPageTitle } from '../utils/pageTitles';

const Index = () => {
    const location = useLocation();

    // Set page title based on current route
    useEffect(() => {
        try {
            const pageTitle = getPageTitle(location.pathname);
            const fullTitle = `SFL - ${pageTitle} | Admin`;
            document.title = fullTitle;
        } catch (error) {
            console.error('Error setting page title:', error);
            // Fallback to default title
            document.title = 'Sports for Life - Admin';
        }
    }, [location.pathname]);

    return (
        <React.Fragment>
            <Routes>
                <Route>
                    {publicRoutes.map((route: any, idx: number) => (
                        <Route
                            key={idx}
                            path={route.path}
                            element={<NonAuthLayout> {route.component} </NonAuthLayout>}
                        />
                    ))}
                </Route>

                <Route>
                    {authProtectedRoutes.map((route: any, idx: number) => (
                        
                        <Route
                            key={idx}
                            path={route.path}                            
                            element={<AuthProtected><Layout>{route.component}</Layout> </AuthProtected>}
                        />
                    ))}
                </Route>
            </Routes>
        </React.Fragment>
    );
}

export default Index;